---
title: "Defekt melden"
slug: reporting-a-defect
description: "Schritt-für-Schritt-Anleitung zum Erfassen eines Schadens oder Defekts an einem Paket mit Foto-Dokumentation."
keywords:
  - Defekt
  - Schaden
  - melden
  - Paket
  - GRAI
  - Foto
  - Defektbericht
---

## Voraussetzungen

- Rolle: Scanner, Manager oder Company Admin
- Das betroffene Paket muss eine lesbare GRAI-Kennung tragen
- Mindestens ein Foto oder Video des Schadens muss bereitstehen

## Schritt für Schritt

1. Navigieren Sie im Menü zu **Hilfe** und wählen Sie **Fehlerberichterstattung**.
2. Geben Sie die GRAI-Kennung des beschädigten Pakets ein oder scannen Sie den QR-Code.
3. Wählen Sie Ihren aktuellen Standort aus dem Dropdown **Standort**.
4. Fügen Sie unter **Defektbeschreibung** eine genaue Schilderung des Schadens ein, z. B. „eingerissene Ecke", „beschädigte Versiegelung" oder „Wasserschaden". Mindestens 10 Zeichen sind erforderlich.
5. Klicken Sie unter **Fotos/Videos** auf **Klicken Sie, um Bilder oder Videos hochzuladen** und wählen Sie mindestens eine Datei aus. Maximal 5 Dateien (JPG, PNG, GIF, MP4, MOV, AVI oder WebM).
6. Klicken Sie auf **Defekt melden**, um den Bericht abzusenden.
7. Das hey circle Support-Team erhält eine Prüfaufgabe und meldet sich bei Ihnen.

## Wenn es schiefgeht

- **"Bitte geben Sie eine Beschreibung an"** — Das Beschreibungsfeld ist leer oder enthält weniger als 10 Zeichen. Ergänzen Sie eine aussagekräftige Schadensbeschreibung.
- **"Mindestens ein Foto oder Video ist erforderlich"** — Laden Sie vor dem Absenden mindestens eine Mediendatei hoch.
- **"Paket nicht gefunden"** — Überprüfen Sie die eingegebene Paket-ID.
- **"Sie sind nicht berechtigt, an diesem Standort Defekte zu melden"** — Wenden Sie sich an Ihren Company Admin, um die Standortzuweisung zu prüfen.
- **Netzwerkfehler** — Der Bericht wurde nicht übermittelt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.
- Kontaktieren Sie uns: support@heycircle.com oder nutzen Sie die Feedback-Schaltfläche unten rechts auf dem Bildschirm.

## Verwandte Artikel

- [Pakete empfangen](/app/help?article=scanning-a-package)
- [Pakete senden](/app/help?article=sending-a-package)
- [Analysen lesen](/app/help?article=viewing-analytics)
